import styled from 'styled-components';

export { default as StyledToggle } from '../../../Toggle';

export const ToggleRow = styled.div`
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
